import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/**
 * @param {string} label - The text displayed above the input
 * @param {string} placeholder - The ghost text inside the input
 * @param {string} type - 'text', 'password', 'email', 'tel', etc.
 * @param {string} name - The key used for form data
 * @param {boolean} required - Whether to show the asterisk and enforce validation
 */
const InputField = ({
    label,
    placeholder,
    type = "text",
    name,
    id,
    required = false,
    value,
    onChange,
    onWheel = () => {},
    ...rest
}) => {
    const [showPassword, setShowPassword] = useState(false);

    // Determine if this is a password field and what the current display type should be
    const isPassword = type === "password";
    const currentType = isPassword && showPassword ? "text" : type;

    const toggleVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <div className="w-full font-body mb-4">
            <label htmlFor={id || name} className="block font-body text-base mb-2">
                {label}
                {required && "*"}
            </label>

            <div className="relative">
                <input
                    {...rest}
                    type={currentType}
                    id={id || name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    onWheel={onWheel}
                    className={`w-full bg-white text-txt-main px-4 py-3 rounded-noq-sm 
                     border border-border-color focus:outline-none focus:ring-2 
                     focus:ring-background-dark transition-all duration-200 
                     placeholder:text-txt-sec text-base shadow-sm ${isPassword ? "pr-12" : ""}`}
                />

                {isPassword && (
                    <button
                        type="button"
                        onClick={toggleVisibility}
                        className="absolute right-4 top-1/2 -translate-y-1/2 text-txt-sec hover:text-txt-main transition-colors duration-200 flex items-center justify-center"
                        tabIndex="-1" // Prevents tabbing to the icon for a faster keyboard flow
                    >
                        {showPassword ? (
                            <EyeSlash size={24} weight="regular" />
                        ) : (
                            <Eye size={24} weight="regular" />
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default InputField;
